/**
 * Auditoría de cambios de matriz (spec 2026-10-06 Fases 1 y 4): a quién
 * (targetUid), dónde (resourcePath) y si es la matriz de la EMPRESA o de una
 * CARPETA (origin). Módulo puro.
 */
const segs = (p) => (typeof p === 'string' ? p.split('/').filter(Boolean) : []);

export const originOfMatrixPath = (path) => {
  const s = segs(path);
  return s.length === 4 && s[0] === 'folders' && s[2] === 'users' ? 'empresa' : 'carpeta';
};

export const buildPermissionsAudit = ({ eventType, actorUid, targetUid, matrixPath, before, action }) => ({
  uid: actorUid,
  eventType,
  targetUid,
  resourcePath: matrixPath,
  origin: originOfMatrixPath(matrixPath),
  action: action || (before ? 'update' : 'create'),
});

export default buildPermissionsAudit;
